import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2de1dc5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "segment-manual-tags",
  class: "main-content-wrapper"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "main-content-page-title" }, "セグメント用手動タグ登録", -1))
const _hoisted_3 = { class: "list-staff-body" }
const _hoisted_4 = { class: "w-full flex gap-3 justify-content-end pr-3" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "flex align-items-center justify-content-between w-full" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-times text-sm" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "list-staff-body" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: /*#__PURE__*/_normalizeStyle([{ 'background-color': '#b5dbff' }]),
  class: "px-3 py-1 border-round-lg w-6rem text-center text-white text-sm uppercase white-space-nowrap"
}, " #b5dbff ", -1))
const _hoisted_13 = { class: "w-full flex gap-3 justify-content-end pr-3" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-normal mb-2 block" }, [
  /*#__PURE__*/_createTextVNode("カテゴリー名"),
  /*#__PURE__*/_createElementVNode("span", { class: "pl-1 text-red" }, "必須")
], -1))
const _hoisted_18 = {
  key: 0,
  class: "p-error text-sm mt-3 d-block"
}
const _hoisted_19 = { class: "col-12" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-normal mb-2 block" }, "表示順序", -1))
const _hoisted_21 = { class: "col-12 flex justify-content-center mt-2 gap-3" }
const _hoisted_22 = { class: "col-12" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-normal mb-2 block" }, [
  /*#__PURE__*/_createTextVNode("名前"),
  /*#__PURE__*/_createElementVNode("span", { class: "pl-1 text-red" }, "必須")
], -1))
const _hoisted_24 = {
  key: 0,
  class: "p-error text-sm mt-3 d-block"
}
const _hoisted_25 = { class: "col-12" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-normal mb-2 block" }, "カテゴリー", -1))
const _hoisted_27 = {
  key: 0,
  class: "p-error text-sm mt-3 d-block"
}
const _hoisted_28 = { class: "col-12 flex justify-content-center mt-2 gap-3" }

import { onBeforeMount, ref, inject, computed } from "vue";
import { get, set } from "@vueuse/core";

// コンポーネントのインポート
import Header from "@/clinic/components/atoms/Grid/header.vue";
import Grid from "@/clinic/components/atoms/Grid/index.vue";
import Paginator from "@/clinic/components/atoms/Paginator/index.vue";

// PrimeVue関連のインポート
import Toast from "primevue/toast";
import { useToast } from "primevue/usetoast";
import { useConfirm } from "primevue/useconfirm";
import Dropdown from "primevue/dropdown";
import InputNumber from "primevue/inputnumber";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import { PageState } from "primevue/paginator";

// サービスのインポート
import ManualTagService from "@/clinic/services/manual-tag.services";
import TagCategoryServices from "@/clinic/services/tag-category.services";

// 定数のインポート
import { DEFAULT_PAGINATOR_ROWS } from "@/clinic/typings/constants/paginator";

// 型定義のインポート
import type { ITag } from "@/clinic/typings/entities/tag";

// ユーティリティ関数のインポート
import { notityErrorMsg, notifySuccessMsg } from "@/clinic/utils/notify-utils";

/** 確認ダイアログのインスタンス */

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

/**
 * セグメント用手動タグ管理ページ
 * タグカテゴリーと手動タグの作成、編集、削除機能を提供する
 */

// Vue関連のインポート
const confirm = useConfirm();

/** クリニックID */
const clinicId = ref(0);

/** トースト通知のインスタンス */
const toast = useToast();

/**
 * カテゴリー関連の状態管理
 */
/** タグカテゴリー一覧 */
const tagCategories = ref<any[]>([]);

/** カテゴリーフォームダイアログの表示状態 */
const tagCategoryFormVisible = ref(false);

/** 選択中のタグカテゴリー（編集用） */
const selectedTagCategory = ref<any>({});

/** カテゴリー名のバリデーションエラー */
const tagCategoryNameError = ref("");

/**
 * 手動タグ関連の状態管理
 */
/** 手動タグのページあたりの表示件数 */
const manualTagRows = ref(DEFAULT_PAGINATOR_ROWS / 2);

/** 手動タグの総件数 */
const manualTagTotalCount = ref(0);

/** 手動タグのページネーション開始位置 */
const manualTagFirst = ref<number>(0);

/** 手動タグの検索キーワード */
const manualTagSearchTerm = ref("");

/** 手動タグフォームダイアログの表示状態 */
const manualTagFormVisible = ref(false);

/** 手動タグ名 */
const manualTagName = ref("");

/** 手動タグ名のバリデーションエラー */
const manualTagNameError = ref("");

/** 手動タグカテゴリーのバリデーションエラー */
const manualTagCategoryError = ref("");

/** 手動タグ一覧 */
const manualTags = ref<ITag[]>([]);

/** 編集対象の手動タグID */
const manualTagId = ref<number | null>(null);

/** 選択中の手動タグカテゴリーID */
const selectedManualTagCategory = ref<number | null>(null);

/** 利用可能なタグカテゴリー一覧 */
const availableTagCategories = ref<any[]>([]);

/** カテゴリーフィルターで選択されたカテゴリーID */
const selectedCategoryFilter = ref<number | null>(null);

/**
 * タグカテゴリーのグリッドカラム定義
 * カテゴリーID、カテゴリー名、表示順序、アクションの4カラムを定義
 */
const tagCategoryColumns = ref<any[]>([
  { field: "id", header: "カテゴリーID", class: "col-1" },
  { field: "name", header: "カテゴリー名", class: "col-3" },
  { field: "position_number", header: "表示順序", class: "col-2" },
  { field: "actions", header: "" },
]);

/**
 * 手動タグのグリッドカラム定義
 * タグID、カテゴリー、名前、色、アクションの5カラムを定義
 */
const manualTagColumns = ref<any[]>([
  { field: "id", header: "タグID", class: "col-1" },
  { field: "category_name", header: "カテゴリー", class: "col-3" },
  { field: "name", header: "名前", class: "col-3", style: "white-space: pre" },
  { field: "color", header: "色", class: "col-3 pr-3" },
  { field: "actions", header: "" },
]);

/**
 * クリニックIDパラメータを取得
 * クリニックIDの型変換とデフォルト値設定を行う
 * @returns {Promise<{clinic_id: number}>} クリニックIDパラメータ
 */
const clinicIdParams = async () => {
  // clinicIdから値を取得
  const clinic_id_raw = get(clinicId);
  let clinic_id: any;

  // refオブジェクトの場合は_valueを取得
  if (clinic_id_raw && typeof clinic_id_raw === "object" && "_value" in clinic_id_raw) {
    clinic_id = (clinic_id_raw as any)._value;
  } else {
    clinic_id = clinic_id_raw;
  }

  let actualClinicId;

  if (clinic_id !== undefined && clinic_id !== null && clinic_id !== 0) {
    if (typeof clinic_id === "number" && !isNaN(clinic_id)) {
      actualClinicId = clinic_id;
    } else if (typeof clinic_id === "string" && clinic_id) {
      const parsed = Number(clinic_id);
      actualClinicId = isNaN(parsed) ? 1 : parsed;
    } else {
      actualClinicId = 1;
    }
  } else {
    actualClinicId = 1;
  }

  return { clinic_id: actualClinicId };
};

/**
 * カテゴリー関連の関数
 */

/**
 * タグカテゴリー一覧を取得
 * APIからカテゴリーデータを取得して状態を更新する
 */
const loadTagCategories = async () => {
  try {
    const params = {
      ...(await clinicIdParams()),
      page: 1,
      rows: 100,
    };
    const { data } = await TagCategoryServices.fetchCategories(
      params,
      () => {
        /* noop */
      },
      () => {
        /* noop */
      },
      () => {
        /* noop */
      }
    );
    const categories = get(data)?.categories || [];
    set(tagCategories, categories);
    set(availableTagCategories, categories);
  } catch (error) {
    console.error("カテゴリーの取得に失敗しました:", error);
    set(tagCategories, []);
    set(availableTagCategories, []);
  }
};

/**
 * カテゴリー作成ダイアログを表示
 */
const addTagCategory = () => {
  set(selectedTagCategory, { name: "", position_number: 0 });
  set(tagCategoryFormVisible, true);
  set(tagCategoryNameError, "");
};

/**
 * カテゴリー編集ダイアログを表示
 * @param {number} categoryId - カテゴリーID
 */
const editTagCategory = (categoryId: number) => {
  const category = get(tagCategories).find((c: any) => c.id == categoryId);
  if (category) {
    set(selectedTagCategory, { ...category });
    set(tagCategoryFormVisible, true);
    set(tagCategoryNameError, "");
  }
};

/**
 * カテゴリーの削除処理
 * 確認ダイアログを表示し、承認時は削除APIを呼び出し
 * @param {number} categoryId - カテゴリーID
 */
const deleteTagCategory = async (categoryId: number) => {
  confirm.require({
    defaultFocus: "",
    message: "このカテゴリーを削除しますか？",
    header: "カテゴリーの削除",
    rejectLabel: "キャンセル",
    acceptLabel: "削除",
    acceptClass: "p-button",
    accept: async () => {
      try {
        await TagCategoryServices.deleteCategory(
          { id: categoryId, ...(await clinicIdParams()) },
          async () => {
            notifySuccessMsg(toast, "カテゴリーを正常に削除しました");
            await loadTagCategories();
          },
          (errors: any) => {
            // APIから返されるエラーメッセージを表示
            if (errors && errors.errors && Array.isArray(errors.errors)) {
              const errorMessage = errors.errors[0];
              if (errorMessage.includes("関連するタグが存在するため削除できません")) {
                notityErrorMsg(toast, "関連するタグが存在するため削除できません");
              } else {
                notityErrorMsg(toast, errorMessage);
              }
            } else if (errors && Array.isArray(errors)) {
              const errorMessage = errors[0];
              if (errorMessage.includes("関連するタグが存在するため削除できません")) {
                notityErrorMsg(toast, "関連するタグが存在するため削除できません");
              } else {
                notityErrorMsg(toast, errorMessage);
              }
            } else if (errors && typeof errors === "string") {
              if (errors.includes("関連するタグが存在するため削除できません")) {
                notityErrorMsg(toast, "関連するタグが存在するため削除できません");
              } else {
                notityErrorMsg(toast, errors);
              }
            } else {
              notityErrorMsg(toast, "カテゴリーの削除に失敗しました");
            }
          }
        );
      } catch (error) {
        notityErrorMsg(toast, "カテゴリーの削除に失敗しました。");
      }
    },
  });
};

/**
 * カテゴリー名のバリデーション
 */
const validateTagCategory = () => {
  set(tagCategoryNameError, "");
  if (!get(selectedTagCategory).name) {
    set(tagCategoryNameError, "カテゴリー名は必須です");
  }
};

/**
 * カテゴリーの保存処理
 * 作成または更新のAPIを呼び出し、成功時は一覧を再取得
 */
const handleSaveTagCategory = async () => {
  validateTagCategory();
  if (get(tagCategoryNameError)) {
    return;
  }

  const params = {
    ...(await clinicIdParams()),
    name: get(selectedTagCategory).name,
    position_number: get(selectedTagCategory).position_number || 0,
  };

  if (get(selectedTagCategory).id) {
    // 更新
    await TagCategoryServices.saveCategory(
      { ...params, id: get(selectedTagCategory).id },
      async () => {
        notifySuccessMsg(toast, "正常に更新されました");
        set(tagCategoryFormVisible, false);
        await loadTagCategories();
      },
      (errors: any) => {
        // APIから返されるエラーメッセージを表示
        if (errors && errors.errors && Array.isArray(errors.errors)) {
          const errorMessage = errors.errors[0];
          if (errorMessage.includes("すでに存在します")) {
            set(tagCategoryNameError, "同一名のカテゴリーは複数登録出来ません");
          } else {
            notityErrorMsg(toast, errorMessage);
          }
        } else if (errors && Array.isArray(errors)) {
          const errorMessage = errors[0];
          if (errorMessage.includes("すでに存在します")) {
            set(tagCategoryNameError, "同一名のカテゴリーは複数登録出来ません");
          } else {
            notityErrorMsg(toast, errorMessage);
          }
        } else if (errors && typeof errors === "string") {
          if (errors.includes("すでに存在します")) {
            set(tagCategoryNameError, "同一名のカテゴリーは複数登録出来ません");
          } else {
            notityErrorMsg(toast, errors);
          }
        }
      }
    );
  } else {
    // 作成
    await TagCategoryServices.saveCategory(
      params,
      async () => {
        notifySuccessMsg(toast, "正常に作成されました");
        set(tagCategoryFormVisible, false);
        await loadTagCategories();
      },
      (errors: any) => {
        // APIから返されるエラーメッセージを表示
        if (errors && errors.errors && Array.isArray(errors.errors)) {
          const errorMessage = errors.errors[0];
          if (errorMessage.includes("すでに存在します")) {
            set(tagCategoryNameError, "同一名のカテゴリーは複数登録出来ません");
          } else {
            notityErrorMsg(toast, errorMessage);
          }
        } else if (errors && Array.isArray(errors)) {
          const errorMessage = errors[0];
          if (errorMessage.includes("すでに存在します")) {
            set(tagCategoryNameError, "同一名のカテゴリーは複数登録出来ません");
          } else {
            notityErrorMsg(toast, errorMessage);
          }
        } else if (errors && typeof errors === "string") {
          if (errors.includes("すでに存在します")) {
            set(tagCategoryNameError, "同一名のカテゴリーは複数登録出来ません");
          } else {
            notityErrorMsg(toast, errors);
          }
        }
      }
    );
  }
};

/**
 * カテゴリーフォームダイアログを閉じる
 */
const closeTagCategoryPopupForm = () => {
  set(selectedTagCategory, {});
  set(tagCategoryFormVisible, false);
};

/**
 * 手動タグ関連の関数
 */

/**
 * 手動タグのページネーション処理
 * @param {string} fromId - ページネーターのID
 * @param {PageState} pageState - ページ状態情報
 */
const manualTagPaging = async (_fromId: string, { first: newFirst }: PageState) => {
  if (newFirst === manualTagFirst.value) {
    return;
  }
  manualTagFirst.value = newFirst;
  await loadManualTags();
};

/**
 * 手動タグ一覧を取得
 * APIから手動タグデータを取得して状態を更新する
 */
const loadManualTags = async () => {
  const page = Math.floor(manualTagFirst.value / manualTagRows.value) + 1;
  const params: any = {
    ...(await clinicIdParams()),
    type: "manual",
    term: get(manualTagSearchTerm),
    page: page,
    rows: manualTagRows.value,
  };

  // カテゴリーフィルターが選択されている場合は追加
  if (get(selectedCategoryFilter)) {
    params.tag_category_id = get(selectedCategoryFilter);
  }

  try {
    const { data } = await ManualTagService.fetchTags(
      params,
      () => {
        /* noop */
      },
      () => {
        /* noop */
      },
      () => {
        /* noop */
      }
    );

    const tags = get(data)?.tags || [];
    const meta = get(data)?.meta || {};

    set(manualTags, tags);
    set(manualTagTotalCount, meta.total_count || tags.length);
  } catch (error) {
    set(manualTags, []);
    set(manualTagTotalCount, 0);
  }
};

/**
 * 手動タグ作成ダイアログを表示
 */
const addManualTag = () => {
  set(manualTagName, "");
  manualTagId.value = null;
  set(selectedManualTagCategory, null);
  set(manualTagFormVisible, true);
  set(manualTagNameError, "");
  set(manualTagCategoryError, "");
};

/**
 * 手動タグ編集ダイアログを表示
 * @param {number} tagId - タグID
 */
const editManualTag = (tagId: number) => {
  const tag = get(manualTags).find((t: ITag) => t.id == tagId);
  if (tag) {
    set(manualTagName, tag.name);
    manualTagId.value = tag.id;
    set(selectedManualTagCategory, tag.tag_category_id || null);
    set(manualTagFormVisible, true);
    set(manualTagNameError, "");
    set(manualTagCategoryError, "");
  }
};

/**
 * 手動タグの削除処理
 * 確認ダイアログを表示し、承認時は削除APIを呼び出し
 * @param {number} tagId - タグID
 */
const deleteManualTag = async (tagId: number) => {
  confirm.require({
    defaultFocus: "",
    message: "すべての顧客からこのタグが解除されます。 このタグ を削除しますか？",
    header: "タグの削除",
    rejectLabel: "キャンセル",
    acceptLabel: "削除",
    acceptClass: "p-button",
    accept: async () => {
      try {
        const params = await clinicIdParams();
        await ManualTagService.deleteTag(
          { id: tagId, ...params },
          () => {
            /* noop */
          },
          () => {
            /* noop */
          }
        );
        await loadManualTags();
        notifySuccessMsg(toast, "タグを正常に削除しました");
      } catch (error) {
        notityErrorMsg(toast, "タグの削除に失敗しました。しばらく時間をおいて再度お試しください。");
      }
    },
  });
};

/**
 * 手動タグの検索処理
 * @param {any} event - 検索イベント
 */
const onManualTagSearch = async (event: any) => {
  set(manualTagSearchTerm, event.currentTarget?.value);
  manualTagFirst.value = 0;
  await loadManualTags();
};

/**
 * カテゴリーフィルターの変更を処理
 * @param {any} event - カテゴリーフィルターのイベント
 */
const onCategoryFilterChange = async (event: any) => {
  set(selectedCategoryFilter, event.value);
  manualTagFirst.value = 0;
  await loadManualTags();
};

/**
 * カテゴリーフィルターをクリアする
 */
const clearCategoryFilter = () => {
  set(selectedCategoryFilter, null);
  manualTagFirst.value = 0;
  loadManualTags();
};

/**
 * 選択されたカテゴリーの名前を取得
 * @param {number | null} categoryId - カテゴリーID
 * @returns {string} カテゴリー名
 */
const getSelectedCategoryName = (categoryId: number | null) => {
  const category = get(availableTagCategories).find((c: any) => c.id === categoryId);
  return category ? category.name : "カテゴリーで絞り込む";
};

/**
 * 手動タグ名のバリデーション
 */
const validateManualTag = () => {
  set(manualTagNameError, "");
  if (!get(manualTagName)) {
    set(manualTagNameError, "名前は必須です");
  }
};

/**
 * 手動タグカテゴリーのバリデーション
 */
const validateManualTagCategory = () => {
  set(manualTagCategoryError, "");
  if (!get(selectedManualTagCategory)) {
    set(manualTagCategoryError, "カテゴリーは必須です");
  }
};

/**
 * 手動タグの保存処理
 * 作成または更新のAPIを呼び出し、成功時は一覧を再取得
 */
const handleSaveManualTag = async () => {
  // 名前とカテゴリーのバリデーションを先に実行
  validateManualTag();
  validateManualTagCategory();
  if (get(manualTagNameError) || get(manualTagCategoryError)) {
    return;
  }

  const body = {
    id: manualTagId.value,
    name: get(manualTagName),
    type: "manual",
    tag_category_id: get(selectedManualTagCategory),
    ...(await clinicIdParams()),
  };

  try {
    await ManualTagService.saveTag(
      body,
      async () => {
        notifySuccessMsg(toast, "タグは正常に保存されました。");
        set(manualTagFormVisible, false);
        await loadManualTags();
      },
      (errors: any) => {
        // APIから返されるエラーメッセージを表示
        if (errors && errors.errors && Array.isArray(errors.errors)) {
          notityErrorMsg(toast, errors.errors[0]);
        } else if (errors && Array.isArray(errors)) {
          notityErrorMsg(toast, errors[0]);
        } else if (errors && typeof errors === "string") {
          notityErrorMsg(toast, errors);
        } else {
          notityErrorMsg(toast, "保存に失敗しました。");
        }
      }
    );
  } catch (error) {
    notityErrorMsg(toast, "保存に失敗しました。");
  }
};

/**
 * カテゴリーダイアログのヘッダー
 * 作成時と編集時で表示を切り替える
 */
const tagCategoryDialogHeader = computed(() =>
  !get(selectedTagCategory).name ? "カテゴリーを作成する" : "カテゴリーを編集する"
);

/**
 * カテゴリーのバリデーション状態
 * エラーがない場合にtrueを返す
 */
const validTagCategory = computed(() => !tagCategoryNameError.value);

/**
 * 手動タグダイアログのヘッダー
 * 作成時と編集時で表示を切り替える
 */
const manualTagDialogHeader = computed(() =>
  !manualTagName.value ? "手動タグを作成する" : "オリジナルタグを編集する"
);

/**
 * 手動タグのバリデーション状態
 * エラーがない場合にtrueを返す
 */
const validManualTag = computed(() => !manualTagNameError.value && !manualTagCategoryError.value);

onBeforeMount(async () => {
  const injectedClinicId = await inject("clinicId");
  set(clinicId, injectedClinicId);
  await loadTagCategories();
  await loadManualTags();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(Header, {
      onNew: addTagCategory,
      enableTitle: "",
      createButtonLabel: "作成",
      titleLabel: "カテゴリー管理",
      titleClass: "my-2"
    }),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(Grid, {
        items: tagCategories.value,
        columns: tagCategoryColumns.value
      }, {
        position_number: _withCtx(({ data }) => [
          _createElementVNode("span", null, _toDisplayString(data.position_number !== null && data.position_number !== undefined ? data.position_number : "-"), 1)
        ]),
        actions: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", {
              class: "pi pi-pencil text-green-600",
              onClick: ($event: any) => (editTagCategory(data.id))
            }, null, 8, _hoisted_5),
            _createElementVNode("span", {
              class: "pi pi-trash text-red-600",
              onClick: ($event: any) => (deleteTagCategory(data.id))
            }, null, 8, _hoisted_6)
          ])
        ]),
        _: 1
      }, 8, ["items", "columns"])
    ]),
    _createVNode(Header, {
      enableSearch: "",
      onSearch: onManualTagSearch,
      onNew: addManualTag,
      createButtonLabel: "作成",
      searchPlaceholder: "名前を入力",
      class: "mt-5"
    }, {
      otherSearchButtons: _withCtx(() => [
        _createVNode(_unref(Dropdown), {
          modelValue: selectedCategoryFilter.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedCategoryFilter).value = $event)),
          options: availableTagCategories.value,
          optionLabel: "name",
          optionValue: "id",
          placeholder: "カテゴリーで絞り込む",
          class: "w-19rem",
          dropdownIcon: "pi pi-filter",
          onChange: onCategoryFilterChange
        }, {
          value: _withCtx((slotProps) => [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", null, _toDisplayString(getSelectedCategoryName(slotProps.value)), 1),
              (selectedCategoryFilter.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _withModifiers(clearCategoryFilter, ["stop"]),
                    class: "text-gray-400 hover:text-gray-600 cursor-pointer ml-2 border-none bg-transparent p-0",
                    type: "button"
                  }, _hoisted_10, 8, _hoisted_8))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "options"])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(Grid, {
        items: manualTags.value,
        columns: manualTagColumns.value
      }, {
        color: _withCtx(() => [
          _hoisted_12
        ]),
        category_name: _withCtx(({ data }) => [
          _createElementVNode("span", null, _toDisplayString(data.category_name || "-"), 1)
        ]),
        actions: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", {
              class: "pi pi-pencil text-green-600",
              onClick: ($event: any) => (editManualTag(data.id))
            }, null, 8, _hoisted_14),
            _createElementVNode("span", {
              class: "pi pi-trash text-red-600",
              onClick: ($event: any) => (deleteManualTag(data.id))
            }, null, 8, _hoisted_15)
          ])
        ]),
        _: 1
      }, 8, ["items", "columns"]),
      (manualTagTotalCount.value > manualTagRows.value)
        ? (_openBlock(), _createBlock(Paginator, {
            key: 0,
            id: "pg-manual",
            ref: "pgManual",
            first: manualTagFirst.value,
            "onUpdate:first": _cache[1] || (_cache[1] = ($event: any) => ((manualTagFirst).value = $event)),
            onPaging: manualTagPaging,
            totalRecords: manualTagTotalCount.value,
            rows: manualTagRows.value,
            class: "mt-2"
          }, null, 8, ["first", "totalRecords", "rows"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(Toast), { position: "top-center" }),
    _createVNode(_unref(Dialog), {
      visible: tagCategoryFormVisible.value,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((tagCategoryFormVisible).value = $event)),
      modal: "",
      header: _unref(tagCategoryDialogHeader),
      style: { width: '30vw' },
      draggable: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createVNode(_unref(InputText), {
            class: "mb-2",
            modelValue: selectedTagCategory.value.name,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedTagCategory.value.name) = $event)),
            type: "text",
            placeholder: "カテゴリー名を入力してください",
            onInput: validateTagCategory
          }, null, 8, ["modelValue"]),
          (tagCategoryNameError.value)
            ? (_openBlock(), _createElementBlock("small", _hoisted_18, _toDisplayString(tagCategoryNameError.value), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createVNode(_unref(InputText), {
            modelValue: selectedTagCategory.value.position_number,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedTagCategory.value.position_number) = $event)),
            "aria-describedby": "position-number-help",
            type: "number",
            size: "large",
            min: 0,
            placeholder: "表示順序を入力してください",
            class: "mb-2"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_unref(Button), {
            label: "キャンセル",
            class: "p-button-light",
            onClick: closeTagCategoryPopupForm
          }),
          _createVNode(_unref(Button), {
            label: "保存",
            class: "btn-orange text-white",
            onClick: handleSaveTagCategory,
            disabled: !_unref(validTagCategory)
          }, null, 8, ["disabled"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "header"]),
    _createVNode(_unref(Dialog), {
      visible: manualTagFormVisible.value,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((manualTagFormVisible).value = $event)),
      modal: "",
      header: _unref(manualTagDialogHeader),
      style: { width: '30vw' },
      draggable: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createVNode(_unref(InputText), {
            class: "mb-2",
            modelValue: manualTagName.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((manualTagName).value = $event)),
            type: "text",
            placeholder: "タグ名を入力してください",
            onInput: validateManualTag
          }, null, 8, ["modelValue"]),
          (manualTagNameError.value)
            ? (_openBlock(), _createElementBlock("small", _hoisted_24, _toDisplayString(manualTagNameError.value), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createVNode(_unref(Dropdown), {
            modelValue: selectedManualTagCategory.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedManualTagCategory).value = $event)),
            options: availableTagCategories.value,
            optionLabel: "name",
            optionValue: "id",
            placeholder: "カテゴリーを選択してください",
            class: "w-full",
            showClear: true,
            onChange: validateManualTagCategory
          }, null, 8, ["modelValue", "options"]),
          (manualTagCategoryError.value)
            ? (_openBlock(), _createElementBlock("small", _hoisted_27, _toDisplayString(manualTagCategoryError.value), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_unref(Button), {
            label: "キャンセル",
            class: "p-button-light",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (manualTagFormVisible.value = false))
          }),
          _createVNode(_unref(Button), {
            label: "保存",
            class: "btn-orange text-white",
            onClick: handleSaveManualTag,
            disabled: !_unref(validManualTag)
          }, null, 8, ["disabled"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "header"])
  ]))
}
}

})